import Vue from 'vue'
import MptcfeUtils from 'mptcfe-utils'

window.Vue = Vue
window.MptcfeUtils = MptcfeUtils